// Catalogue icon names (platform-neutral, feather-style) -> MUI icons
import Favorite from '@mui/icons-material/Favorite'
import Bolt from '@mui/icons-material/Bolt'
import WaterDrop from '@mui/icons-material/WaterDrop'
import Air from '@mui/icons-material/Air'
import MonitorHeart from '@mui/icons-material/MonitorHeart'
import Warning from '@mui/icons-material/Warning'
import ContentCut from '@mui/icons-material/ContentCut'
import Check from '@mui/icons-material/Check'
import CheckBox from '@mui/icons-material/CheckBox'
import Settings from '@mui/icons-material/Settings'
import Shuffle from '@mui/icons-material/Shuffle'
import Monitor from '@mui/icons-material/Monitor'
import HighlightOff from '@mui/icons-material/HighlightOff'
import LocalShipping from '@mui/icons-material/LocalShipping'
import Description from '@mui/icons-material/Description'
import Thermostat from '@mui/icons-material/Thermostat'
import Phone from '@mui/icons-material/Phone'
import Home from '@mui/icons-material/Home'
import Groups from '@mui/icons-material/Groups'
import Edit from '@mui/icons-material/Edit'
import Person from '@mui/icons-material/Person'
import TrendingDown from '@mui/icons-material/TrendingDown'
import GpsFixed from '@mui/icons-material/GpsFixed'
import Layers from '@mui/icons-material/Layers'
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked'
import Remove from '@mui/icons-material/Remove'
import Refresh from '@mui/icons-material/Refresh'
import WbSunny from '@mui/icons-material/WbSunny'
import Assignment from '@mui/icons-material/Assignment'
import Visibility from '@mui/icons-material/Visibility'
import ArrowUpward from '@mui/icons-material/ArrowUpward'
import Flag from '@mui/icons-material/Flag'
import List from '@mui/icons-material/List'
import Bedtime from '@mui/icons-material/Bedtime'
import Build from '@mui/icons-material/Build'
import Percent from '@mui/icons-material/Percent'
import Schedule from '@mui/icons-material/Schedule'
import ChildFriendly from '@mui/icons-material/ChildFriendly'
import Psychology from '@mui/icons-material/Psychology'
import LocalFireDepartment from '@mui/icons-material/LocalFireDepartment'
import PregnantWoman from '@mui/icons-material/PregnantWoman'

const ICONS = {
  heart: Favorite,
  zap: Bolt,
  droplet: WaterDrop,
  wind: Air,
  activity: MonitorHeart,
  alert: Warning,
  scissors: ContentCut,
  check: Check,
  'check-square': CheckBox,
  settings: Settings,
  shuffle: Shuffle,
  monitor: Monitor,
  'x-circle': HighlightOff,
  truck: LocalShipping,
  'file-text': Description,
  thermometer: Thermostat,
  phone: Phone,
  home: Home,
  users: Groups,
  edit: Edit,
  user: Person,
  'trending-down': TrendingDown,
  target: GpsFixed,
  layers: Layers,
  circle: RadioButtonUnchecked,
  minus: Remove,
  refresh: Refresh,
  sun: WbSunny,
  clipboard: Assignment,
  eye: Visibility,
  'arrow-up': ArrowUpward,
  flag: Flag,
  list: List,
  moon: Bedtime,
  tool: Build,
  percent: Percent,
  clock: Schedule,
  baby: ChildFriendly,
  brain: Psychology,
  flame: LocalFireDepartment,
}

export const liveIcon = (name, { categoryKey } = {}) => {
  if (categoryKey === 'obstetric') return PregnantWoman
  return ICONS[name] || null
}
